import { render, staticRenderFns } from "./live.vue?vue&type=template&id=02dcf3a0&scoped=true&"
import script from "./live.vue?vue&type=script&lang=js&"
export * from "./live.vue?vue&type=script&lang=js&"
import style0 from "./live.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./live.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./live.vue?vue&type=style&index=2&id=02dcf3a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02dcf3a0",
  null
  
)

export default component.exports